$(document).foundation();

;cart = {
  // Change the quantity of a specific item in the cart
  // id: the variantId of the product to change
  // quantity: the quantity to set for the item
  // function changeItem(id, quantity)
  changeItem : function(id, quantity, success, error)
  {
    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: id,
        quantity: quantity
      },
      success: function(data)
      {
        if (typeof success == "function") success(data);
      },
      error: function(t, r)
      {
        if (typeof error == "function") error(t, r);
      }
    })
  },

  // Retrieves the shipping cost for the items currently in the cart
  getShippingCost : function(){
    return $.ajax({
      url: '/cart/shipping_rates.json?shipping_address%5Bzip%5D=9000&shipping_address%5Bcountry%5D=Denmark'
    });
  }
}

$(document).ready(function() {

  // Tooltipster
  $('.tooltipster').tooltipster({
    'animation' : 'grow',
    'maxWidth' : 300
  });

  // ================================================
  // AJAX - ADD TO CART
  // ================================================
  $('form[action="cart/add"]').on('submit', function(e) { 
    e.preventDefault();  //prevent form from submitting

    var quantity = $(this).find("#quantity").val();
    var id = $(this).find("#id").val();
    var data = {
      quantity : quantity,
      id : id 
    };

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(t){
        refreshCart();
        updateProductText();
        showMessage("Varen er tilføjet din kurv", "success");
      },
      error: function(t,r) {

        showMessage("Kunne ikke tilføje varen til din kurv - prøv igen", "error");      
      }
    });
  });  


  // ================================================
  // MAIN MENU - MINI CART
  // ================================================
  $('#show-cart').hover(
    function () {
      $('#mini-cart', this).stop().slideDown(200);
    },
    function () {
      $('#mini-cart', this).stop().slideUp(200);
    }
  );

  // ================================================
  // MAIN MENU - SEARCH BOX
  // ================================================


  $('body').bind('click', function(e){
    if(e.target.id == "show-search")
      return;

    if(e.target.id == "search-query")
      return;


    $('.search-results').hide();
    $('#show-search').css("width", "100px");
  });

  $('#show-search').on("click", function(e){

    $(this).css("width", "");
    $(this).find("#search-query").focus();

  });



  // ================================================
  // MAIN MENU - SCROLL SETUP
  // ================================================
  // $('header').data('size','big');
  // $("header").addClass("large");

  // $(window).scroll(function() {
  //     if($(document).scrollTop() > 0)
  //     {
  //         if($('header').data('size') == 'big')
  //         {
  //             $('header').data('size','small');
  //             $("header").removeClass("large").addClass("small");
  //         }
  //     }
  //     else
  //     {
  //         if($('header').data('size') == 'small')
  //         {
  //             $('header').data('size','big');
  //             $("header").removeClass("small").addClass("large");
  //         }  
  //     }
  // });


  // ================================================
  // GENERAL FEATURES
  // ================================================
  $("a.post-form").on("click", function(e)
                      {
    e.preventDefault();
    $(this).closest("form").submit();
  });

  $("input[type='text'], input[type='password'],input[type='number'], textarea").click(function () {
    $(this).select();
  });



  // ================================================
  // SEARCH
  // ================================================   

  // Clear the search guck from the values in the form
  var query_val = $("form.search #q").val();
  var input_val = $("form.search #search-query").val();

  $("form.search #q").val(query_val.replace('*', '').replace('AND', '').replace('OR', ''));
  $("form.search #search-query").val(input_val.replace('*', '').replace('AND', '').replace('OR', ''));

  $("form.search").on("submit", function(e){

    var hidden_field = $(this).find("input[type='hidden']#q");
    var query_field = $(this).find("#search-query");
    var search_query = query_field.val();

    var words = search_query.split(" ");
    var search_string = '';
    var i;
    for (i = 0; i < words.length; ++i) {
      if(words[i].length>0){
        if(i > 0){
          //search_string += ' OR '; // OR search
          search_string += ' AND '; // AND search

        }
        search_string += '*'+words[i]+'*';
      }
    }

    hidden_field.val(search_string);
    return true;
  });


  // ================================================
  // ADD TO CART
  // ================================================

  $(".add-to-cart").on("click", function(e)
                       {
    e.preventDefault();
    var form = $(this).closest("form");
    jQuery.post('/cart/add.js', $(form).serialize());


  });
});


$(function() {

  // ================================================
  // MOBILE NAVIGATION
  // ================================================ 

  /*
         * Fix for footer when the keyboard is displayed
         */
  $(document).on('focus', 'input, textarea', function() 
                 {
    $('#menu-mobile-footer').hide();
  });

  $(document).on('blur', 'input, textarea', function() 
                 {
    $('#menu-mobile-footer').show();
  });


  $("#scotch-panel").css("display", "block");
  $("#scotch-panel-cart").css("display", "block");
  $(".inside-panel").css("display", "block");

  // Setup mobile cart
  var panelcart = $('#scotch-panel-cart').scotchPanel({
    containerSelector: '#site-wrapper',
    direction: 'right',
    duration: 300,
    transition: 'ease',
    clickSelector: '.mobile-cart',
    distanceX: '80%',
    enableEscapeKey: true,
    afterPanelOpen: function(){$("html, body").animate({ scrollTop: 0 }, "slow");}
  });

  // Setup main menu
  var panel = $('#scotch-panel').scotchPanel({
    containerSelector: '#site-wrapper',
    direction: 'left',
    duration: 300,
    transition: 'ease',
    clickSelector: '.mobile-menu',
    distanceX: '70%',
    enableEscapeKey: true,
    afterPanelOpen: function(){$("html, body").animate({ scrollTop: 0 }, "slow");}
  });


  // Setup sub panels
  var items = $(".inside-panel");
  items.each(function(){
    var index = $(this).attr("data-index");

    $('.inside-panel-' + index).scotchPanel({
      containerSelector: '#scotch-panel',
      clickSelector: '.toggle-inside-' + index,
      direction: 'left',
      distanceX: '100%',
      beforePanelOpen: function() {
        // Reset all panels
        $('.inside-panel').css('z-index', 0);
        // Bring current panel to top
        $('.inside-panel-' + index).css('z-index', 11);
      },
    });     
  });

  // Close on overlay click
  $('.overlay').click(function() {
    // CLOSE ONLY
    panel.close();
    panelcart.close();
  });

});